import { render, staticRenderFns } from "./BookCardsList.vue?vue&type=template&id=c01c5cfc"
import script from "./BookCardsList.vue?vue&type=script&lang=ts"
export * from "./BookCardsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports